import type { ReactNode } from 'react';

type Props = {
    label: string;
    children: ReactNode;
};

export function ProfileDetailsRow({ label, children }: Props) {
    return (
        <div className="grid grid-cols-[6.25rem_1fr] gap-x-6 border-b border-border py-4 last:border-b-0 sm:grid-cols-[14rem_1fr] sm:gap-x-10">
            <dt className="text-base text-foreground">{label}</dt>
            <dd className="flex min-w-0 flex-col gap-1 break-words">{children}</dd>
        </div>
    );
}
